// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tooltip_class .arrow:before{border-top-color:#f0ad4e!important;border-bottom-color:#f0ad4e!important}.tooltip_class .tooltip-inner{border:1px solid #f0ad4e!important}", ""]);
// Exports
module.exports = exports;
